<template>
  <modal
    event-tracking-source="Dunning process popup"
    @close="closeModal"
  >
    <div class="w-full h-full px-6 py-10 lg:p-12 container">
      <div class="lg:px-2">
        <div class="flex justify-center mb-4">
          <i class="fa-regular fa-triangle-exclamation text-[32px] text-b40" />
        </div>
        <div
          class="text-2xl font-semibold text-b30 leading-8 mb-2 lg:mb-4 px-4 text-center"
        >
          We couldn’t process your last payment
        </div>
        <p
          class="text-base lg:text-lg text-center text-b30"
        >
          Please update your payment method to keep your account active
        </p>
        <div class="flex align-center justify-center">
          <button
            class="al-btn al-btn--purple w-auto px-10 mx-auto mt-8 mb-4 lg:mb-0"
            @click="redirectToPaymentMethod"
          >
            <span>Update Now</span>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';
import { SESSION_NAMES } from '@/constants';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isDunningPopupClosed() {
      return this.$store.state.subscription?.isDunningPopupClosed;
    },
    currentRoute() {
      return this.$router.currentRoute;
    },
    isAdmin() {
      return this.$store.state.user?.is_team_admin;
    },
  },
  watch: {
    isDunningPopupClosed() {
      this.isOpen = !this.isDunningPopupClosed;
    },
  },
  mounted() {
    this.isOpen = !this.isDunningPopupClosed;
    if (this.isOpen) {
      eventTracker(analyticsEvents.popupOpen, {
        popup_name: 'Dunning process popup',
      });
    }
  },
  methods: {
    closeModal() {
      sessionStorage.setItem(SESSION_NAMES.IS_DUNNING_POPUP_CLOSED, 'true');
      this.$store.dispatch('setIsDunningPopupClosed', true);
    },
    redirectToPaymentMethod() {
      sessionStorage.setItem(SESSION_NAMES.IS_DUNNING_POPUP_CLOSED, 'true');
      this.$store.dispatch('setIsDunningPopupClosed', true);

      const redirectPath = this.isAdmin ? '/account/team/billing/' : '/account/billing/';
      if (this.currentRoute.path !== redirectPath) {
        window.location.href = redirectPath;
      }
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: 'Update Payment Details',
        click_source: 'Dunning process popup',
        flow: 'Dunning process popup',
        next_URL: 'https://motionarray.com/account/billing',
      });
    },
  },
};
</script>

<style scoped>
.text-\[32px\] {
  font-size: 32px;
}
>>>.modal-container {
  margin-top: 0;
}
@screen sm {
  .container {
    max-width: 368px;
  }
}
</style>
